













import { Component, Vue } from "vue-property-decorator";
// import { LoadJs } from '../utils/functions';

@Component
export default class Footer extends Vue {
  private created() {
    // LoadJs()
  }
}
